export const handleChangeDataSelectBranchPage = (name, value) => ({
    type: 'CHANGE_DATA_PAGE_SELECT_BRANCH', name, value
});